module.exports = __webpack_public_path__ + "static/pawsome-dogs-training-a7bb807455958a63d4377f2de03f7b5a.svg";